import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import { UrlApiEnvasado } from "../../../services/apirest";

function FacturaEspecificaAogas(props) {
  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState([]);
  const [detalles, setDetalles] = useState({}); // Para almacenar los detalles de las facturas por tipo de producto

  useEffect(() => {
    if (!props.precios || props.precios.length === 0) return;

    setLoading(true);

    const fetchFacturas = async () => {
      try {
        const requests = props.precios.flatMap((item) => {
          const compraMax = JSON.parse(item.compra_maxima);
          const compraMin = JSON.parse(item.compra_minima);

          return [
            fetch(
              `${UrlApiEnvasado}db2/api/estadisticaaogas/deudores/especifico/${compraMax.tipo_comp}/${compraMax.suc}/${compraMax.nro}`
            ).then((res) => res.json()),
            fetch(
              `${UrlApiEnvasado}db2/api/estadisticaaogas/deudores/especifico/${compraMin.tipo_comp}/${compraMin.suc}/${compraMin.nro}`
            ).then((res) => res.json()),
          ];
        });

        const responses = await Promise.all(requests);
        setFacturas(responses);

        // Guardamos detalles de las facturas en un objeto para cada tipo de producto
        const detallesFacturas = {};
        responses.forEach((response) => {
          response.forEach((factura) => {
            const tipoProducto = factura.ccd_tipo_comp; // Aquí ajustas si el tipo de producto lo defines diferente
            if (!detallesFacturas[tipoProducto]) {
              detallesFacturas[tipoProducto] = [];
            }
            detallesFacturas[tipoProducto].push(factura);
          });
        });

        setDetalles(detallesFacturas);

      } catch (error) {
        console.error("Error al obtener las facturas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacturas();
  }, [props.precios]);

  const handleClose = () => {
    props.setOpen(false);
  };
  console.log(detalles);
  

  return (
    <Dialog fullWidth open={props.open} onClose={handleClose} maxWidth="md">
      <Box backgroundColor="#1F618D">
        <Grid container backgroundColor="#1F618D" p={1}>
          <Grid item xs={2}>
            <IconButton onClick={handleClose}>
              <ArrowBackIcon sx={{ color: grey[50] }} />
            </IconButton>
          </Grid>
          <Grid item xs={8} container justifyContent="center" alignItems="center">
            <Typography fontSize={20} align="center" color="#ffffff">
              Facturas con valores Mínimos y Máximos
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
          </Box>
        ) : (
          <div>
            {props.precios.map((producto, index) => (
              <div key={index}>
                <Typography variant="h6">{producto.tipo_producto}</Typography>
                <Typography>Máximo: {producto.precio_maximo}</Typography>
                <Typography>Mínimo: {producto.precio_minimo}</Typography>

                {detalles[producto.tipo_producto] && detalles[producto.tipo_producto].length > 0 ? (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tipo</TableCell>
                          <TableCell>Sucursal</TableCell>
                          <TableCell>Número</TableCell>
                          <TableCell>Cliente</TableCell>
                          <TableCell>Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {detalles[producto.tipo_producto].map((factura, index) => (
                          <TableRow key={index}>
                            <TableCell>{factura.ccd_tipo_comp}</TableCell>
                            <TableCell>{factura.ccd_suc}</TableCell>
                            <TableCell>{factura.ccd_nro}</TableCell>
                            <TableCell>{factura.name_cliente}</TableCell>
                            <TableCell>{factura.ccd_total}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography>No se encontraron facturas para este tipo de producto.</Typography>
                )}
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default FacturaEspecificaAogas;
